import cx from 'clsx';
import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as DoubleArrowsIcon } from '@assets/svg/double_v_arrows.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  switchValue: 'byFacility' | 'byGroup';
  onChangeSwitchValue: (id: 'byFacility' | 'byGroup') => void;
  showGroups: boolean;
}

const SWITCH_TOOLTIP_ID = 'switch-tooltip-id';

const GroupFacilitySwitcher: React.FC<IProps> = ({ switchValue, onChangeSwitchValue, showGroups }) => {
  const { t } = useTranslation();

  const nameBySwitchValue = {
    byFacility: t('Facilities'),
    byGroup: t('Groups'),
  };

  return (
    <div className={style.switcherBlock}>
      <div
        className={cx(style.switchValueBlock, { [style.switchDisabled]: !showGroups })}
        data-tooltip-id={SWITCH_TOOLTIP_ID}
      >
        {nameBySwitchValue[switchValue as keyof typeof nameBySwitchValue]}
        {showGroups && <DoubleArrowsIcon className={style.arrowsIcon} />}
      </div>
      {showGroups && (
        <Tooltip
          id={SWITCH_TOOLTIP_ID}
          place="bottom"
          openOnClick
          className={cx(style.switchPopover, { [style.switchDisabled]: !showGroups })}
          clickable
          disableStyleInjection
          noArrow
          render={() => (
            <>
              {switchValue === 'byGroup' && (
                <div className={style.switchPopoverItem} onClick={() => onChangeSwitchValue('byFacility')}>
                  {t('Facilities')}
                </div>
              )}
              {switchValue === 'byFacility' && (
                <div className={style.switchPopoverItem} onClick={() => onChangeSwitchValue('byGroup')}>
                  {t('Groups')}
                </div>
              )}
            </>
          )}
        />
      )}
    </div>
  );
};

export default GroupFacilitySwitcher;
